"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapLayerSwitcherBaseLayers = void 0;
var MapLayerSwitcherBaseLayers = /** @class */ (function () {
    function MapLayerSwitcherBaseLayers(_map, _mapStore, _baseLayers, _mappingTextPack, _config) {
        var _this = this;
        this._map = _map;
        this._mapStore = _mapStore;
        this._baseLayers = _baseLayers;
        this._mappingTextPack = _mappingTextPack;
        this._config = _config;
        this._initialised = false;
        this.init = function () {
            if (!_this._initialised) {
                _this.addOpacitySlider(_this._mapStore.getMapInfo().opacity);
                _this.addBaseLayers();
                _this._initialised = true;
            }
        };
        this.addOpacitySlider = function (defaultOpacity) {
            _this._opacity = defaultOpacity;
            var onOpacityChanged = function (elem) {
                _this._opacity = elem.val() / 100;
                var opacityForScope = _this._opacity;
                for (var _i = 0, _a = _this._baseLayers; _i < _a.length; _i++) {
                    var l = _a[_i];
                    if (l.getVisible()) {
                        l.setOpacity(opacityForScope);
                    }
                }
                _this._mapStore.onOpacityChanged(_this._opacity);
            };
            //set initial opacity too
            for (var _i = 0, _a = _this._baseLayers; _i < _a.length; _i++) {
                var l = _a[_i];
                if (l.getVisible()) {
                    l.setOpacity(defaultOpacity);
                }
            }
            if ($(".mapSlider")[0]) {
                $(".mapSlider").slider({
                    min: 20,
                    max: 100,
                    value: defaultOpacity * 100
                }).on('change', function () {
                    onOpacityChanged($(this));
                });
                $(".mapSliderContainer .tooltip").hide();
            }
        };
        this.addBaseLayers = function () {
            //add the base layers to the layer switcher
            var ul = $("<ul>", { "class": "esdm-layer-switcher" });
            var pnl = $("#panelBaseLayers").append(ul);
            var self = _this;
            var _loop_1 = function (bLyr) {
                var li = $("<li>");
                var lyrId = "BaseLayer" + bLyr.ref;
                var input = $("<input>", { id: lyrId, "type": "radio", "name": "base", "checked": bLyr.getVisible() });
                input.change(function () {
                    self.onBaseLayerVisibiltyChanged(bLyr, $(this).prop("checked"));
                });
                li.append(input);
                li.append($("<label>", { for: lyrId, html: bLyr.displayName }));
                ul.append(li);
            };
            for (var _i = 0, _a = _this._baseLayers; _i < _a.length; _i++) {
                var bLyr = _a[_i];
                _loop_1(bLyr);
            }
        };
        this.onBaseLayerVisibiltyChanged = function (bLyr, visible) {
            _this.setBaseLayerVisible(bLyr, visible);
            _this._mapStore.onBaseLayerChanged(bLyr.ref, visible);
            bLyr.setOpacity(_this._opacity);
            _this._map.raiseOnBaseLayerVisibilityChanged({
                baseLayer: bLyr,
                visible: visible
            });
        };
        this.setBaseLayerVisible = function (lyr, visible) {
            if (visible) {
                lyr.setVisible(visible);
                for (var _i = 0, _a = _this._baseLayers; _i < _a.length; _i++) {
                    var l = _a[_i];
                    if (l != lyr) {
                        l.setVisible(false);
                        _this._mapStore.onBaseLayerChanged(l.ref, false);
                    }
                }
            }
        };
        this.init();
    }
    return MapLayerSwitcherBaseLayers;
}());
exports.MapLayerSwitcherBaseLayers = MapLayerSwitcherBaseLayers;
//# sourceMappingURL=MapLayerSwitcherBaseLayers.js.map